@let name = roomName() || ('No Room' | translate);
@let status = statusClass();
@let joined = inConference();

<ng-template #shareOptions let-menu>
  <button type="button" class="rin-menu__item" (click)="actions.copyInvite(); menu.close()">
    <fa-duotone-icon class="rin-menu__icon" [icon]="faLink"></fa-duotone-icon>
    <span>{{ 'Copy invite link' | translate }}</span>
  </button>
  <button type="button" class="rin-menu__item" (click)="actions.shareViaEmail(); menu.close()">
    <fa-duotone-icon class="rin-menu__icon" [icon]="faEnvelope"></fa-duotone-icon>
    <span>{{ 'Share via email' | translate }}</span>
  </button>
  <button type="button" class="rin-menu__item" (click)="actions.openCalendar(); menu.close()">
    <fa-duotone-icon class="rin-menu__icon" [icon]="faCalendarPlus"></fa-duotone-icon>
    <span>{{ 'Add to calendar' | translate }}</span>
  </button>
</ng-template>

<ng-template #userCountPill>
  @let users = userCount();
  @let usersLabel = '[count] in the room' | translate: { count: users };
  <span
    class="rin__users"
    role="img"
    [attr.aria-label]="usersLabel"
    [andorTooltip]="usersLabel"
    tooltipPosition="below">
    <fa-duotone-icon class="rin__users-icon" [icon]="faUser"></fa-duotone-icon>
    <span>{{ users }}</span>
  </span>
</ng-template>

<div class="rin">
  <div class="rin__identity">
    <div class="rin__title">
      <span
        class="rin__dot rin__dot--{{ status }}"
        role="img"
        [attr.aria-label]="statusLabel() | translate"
        [andorTooltip]="statusLabel() | translate"
        tooltipPosition="below"></span>
      <button
        type="button"
        class="rin__name"
        [andorTooltip]="'Copy invite link' | translate"
        tooltipPosition="below"
        (click)="actions.copyInvite()">
        {{ name }}
      </button>
      @if (status !== 'ok') {
        <span class="rin__status rin__status--{{ status }}">{{ statusLabel() | translate }}</span>
      }
    </div>
    @if (joined) {
      <div class="rin__pills">
        <ng-container [ngTemplateOutlet]="userCountPill" />
        <andor-meeting-time mode="pills" />
      </div>
    }
  </div>

  <div class="rin__actions">
    @if (joined) {
      <andor-meeting-time class="rin__chip" mode="chip" />
      <andor-room-files />
    }
    <andor-square-icon-btn
      class="rin__wide"
      [variant]="shareMenu.isOpen() ? 'active' : 'default'"
      [tooltip]="shareMenu.isOpen() ? '' : ('Share' | translate)"
      [ariaLabel]="'Share' | translate"
      tooltipPosition="below"
      [andorContextMenuTriggerFor]="shareMenu">
      <fa-duotone-icon [icon]="faShareFromSquare"></fa-duotone-icon>
    </andor-square-icon-btn>
    <andor-square-icon-btn
      class="rin__wide"
      [tooltip]="(colorMode() === 'dark' ? 'Light Mode' : 'Dark Mode') | translate"
      tooltipPosition="below"
      (clicked)="toggleColorMode()">
      <fa-duotone-icon
        [icon]="colorMode() === 'dark' ? faSunBright : faMoonStars"></fa-duotone-icon>
    </andor-square-icon-btn>
    <andor-square-icon-btn
      class="rin__narrow"
      [variant]="moreMenu.isOpen() ? 'active' : 'default'"
      [tooltip]="moreMenu.isOpen() ? '' : ('Room Info' | translate)"
      [ariaLabel]="'Room Info' | translate"
      tooltipPosition="below"
      [andorContextMenuTriggerFor]="moreMenu">
      <fa-duotone-icon [icon]="faBars"></fa-duotone-icon>
    </andor-square-icon-btn>
    @if (showBackHome()) {
      <andor-square-icon-btn
        [tooltip]="'Back to Home' | translate"
        tooltipPosition="below"
        (clicked)="actions.backToHome()">
        <fa-duotone-icon [icon]="faHouse"></fa-duotone-icon>
      </andor-square-icon-btn>
    } @else {
      <andor-square-icon-btn
        variant="danger"
        [tooltip]="'Leave Room' | translate"
        tooltipPosition="below"
        (clicked)="actions.leave()">
        <fa-duotone-icon [icon]="faRightFromBracket"></fa-duotone-icon>
      </andor-square-icon-btn>
    }
  </div>

  @if (joined) {
    <andor-meeting-time class="rin__progress" mode="progress" />
  }
</div>

<andor-context-menu #shareMenu mode="styled" xPosition="before" [overlapTrigger]="false">
  <div class="rin-menu">
    <ng-container
      [ngTemplateOutlet]="shareOptions"
      [ngTemplateOutletContext]="{ $implicit: shareMenu }" />
  </div>
</andor-context-menu>

<!-- Narrow screens: everything the pill has no room for. -->
<andor-context-menu #moreMenu mode="styled" xPosition="before" [overlapTrigger]="false">
  <div class="rin-menu">
    <div class="rin-menu__head">
      <span class="rin__dot rin__dot--{{ status }}" aria-hidden="true"></span>
      <span class="rin-menu__name">{{ name }}</span>
      <span class="rin__status rin__status--{{ status }}">{{ statusLabel() | translate }}</span>
    </div>
    @if (joined) {
      <div class="rin__pills rin-menu__time">
        <ng-container [ngTemplateOutlet]="userCountPill" />
        <andor-meeting-time mode="pills" />
      </div>
    }
    <span class="rin-menu__separator" aria-hidden="true"></span>
    <ng-container
      [ngTemplateOutlet]="shareOptions"
      [ngTemplateOutletContext]="{ $implicit: moreMenu }" />
    <button type="button" class="rin-menu__item" (click)="toggleColorMode()">
      <fa-duotone-icon
        class="rin-menu__icon"
        [icon]="colorMode() === 'dark' ? faSunBright : faMoonStars"></fa-duotone-icon>
      <span>{{ (colorMode() === 'dark' ? 'Light Mode' : 'Dark Mode') | translate }}</span>
    </button>
  </div>
</andor-context-menu>
